import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import localeRu from '@angular/common/locales/ru';
import { registerLocaleData } from '@angular/common';
import { MessageService as PrimeNgMessageService } from 'primeng/api';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { ConfigurationService } from './shared/services/configuration.service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { DisableIeCachingHttpInterceptor } from './shared/interceptors/disable-ie-caching.http-interceptor';
import { HttpErrorHandlingInterceptor } from './shared/interceptors/error-handling.http-interceptor';
import { HttpHeadersInterceptor } from './shared/interceptors/headers.http-interceptor';
import { MathNotationPipe } from './shared/pipes/math-notation.pipe';
import { FileUploadService } from './shared/services/file-upload.service';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ToastrModule } from 'ngx-toastr';
import { MessageService } from './shared/services/message.service';
import { ParticipantService } from './supplier/services/participant.service';
import { FormatCharacteristicPipe } from './shared/pipes/format-characteristic.pipe';
import { MainMenuModule } from './shared/modules/main-menu/main-menu.module';
import { CookieService } from 'ngx-cookie-service';
import { CustomToastModule } from './shared/modules/custom-toast/custom-toast.module';
import { NotificationBannerModule } from './shared/modules/notification-banner/notification-banner.module';
import { NotificationMpsService } from './shared/events/services/notification-mps.service';

registerLocaleData(localeRu);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NoopAnimationsModule,
    SharedModule,
    HttpClientModule,
    MainMenuModule,
    AngularSvgIconModule.forRoot(),
    ToastrModule.forRoot({
      tapToDismiss: false,
      positionClass: 'toast-bottom-right'
    }),
    CustomToastModule,
    NotificationBannerModule,
  ],
  providers: [
    ConfigurationService,
    NotificationMpsService,
    {
      provide: APP_INITIALIZER,
      useFactory: (service: ConfigurationService) => () => service.init(),
      deps: [ConfigurationService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpHeadersInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorHandlingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DisableIeCachingHttpInterceptor,
      multi: true,
    },
    { provide: LOCALE_ID, useValue: 'ru' },
    FileUploadService,
    MathNotationPipe,
    FormatCharacteristicPipe,
    MessageService,
    PrimeNgMessageService,
    ParticipantService,
    CookieService,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
